import { memo } from 'react';
import { useSelector } from 'react-redux';

import { NoSearchResults } from '~/components/NoSearchResults/NoSearchResults';
import { PrivateSearchAllAssetsButton } from '~/components/NoSearchResults/shared/PrivateSearchAllAssetsButton';
import { centralizedBoardTitleSelector } from '~/store/centralizedBoard/selectors';

export const PrivateBoardNoSearchResults = memo(() => {
  const currentBoardTitle = useSelector(centralizedBoardTitleSelector);

  return <NoSearchResults location={currentBoardTitle} action={<PrivateSearchAllAssetsButton />} />;
});

PrivateBoardNoSearchResults.displayName = 'PrivateBoardNoSearchResults';
